module.exports = __webpack_public_path__ + "static/media/showroomIco.544f74e0.svg";